import * as React from 'react';

import LogoSvg from 'vectors/logo.svg';
import { HeaderContainer, LogoWrapper, Left, Right, Bottom } from './styled';

export const Header: HeaderType = ({ children }) => {
  return (
    <HeaderContainer>
      <LogoWrapper>
        <LogoSvg />
      </LogoWrapper>
      {children}
    </HeaderContainer>
  );
};

Header.Left = (props) => {
  return <Left {...props} />;
};

Header.Right = (props) => {
  return <Right {...props} />;
};

Header.Bottom = (props) => {
  return <Bottom {...props} />;
};

type HeaderType = React.FC<{ children?: React.ReactNode }> & {
  Left: React.FC<{ children: React.ReactNode }>;
  Right: React.FC<{ children: React.ReactNode }>;
  Bottom: React.FC<{ children: React.ReactNode }>;
};
